module.exports = __webpack_public_path__ + "static/media/berita_informasi.137ae572.svg";